/**
 * Manager (Collection) for all containers.
 * Now used for a transition between the old and new container format.
 *
 */

var VRC = VRC || {};

VRC.ContainerManager = (function () {

	var importContainers = function (containers) {
		ParseContainers(containers);
	};

	var getContainerById = function (containerId) {
		var container = g_container_list[containerId];

		var containerObject = VRC.Container(container);

		return containerObject;
	};

	var add = function (con, isUpdate) {
		var isUpdate = isUpdate || false;
		//Transformation until we have gotten rid of the old container format
		var oldContainerFormat = new container(con.toJson(), {});

		g_container_list[oldContainerFormat.id] = oldContainerFormat;

		if (isUpdate) {
			oldContainerFormat.UpdateContainerVisual();
		} else {
			oldContainerFormat.InitialiseVisual(G_CONTAINING_DIV);
		}

		UpdateAllDeckTotals();
		UpdateColorMap();

	};

	var update = function (container) {
		add(container, true); //same as this point
	};

	return {
		importContainers: importContainers,
		getContainerById: getContainerById,
		add: add,
		update: update
	}
})();